<template>
  <DropdownField
    inputId="payment-config-type"
    :name="fieldName"
    :label="t('sites.singleSite.financialConfig.paymentInfo.form.type')"
    :placeholder="t('sites.singleSite.financialConfig.paymentInfo.form.typePlaceholder')"
    :options="paymentConfigTypes"
    optionLabel="label"
    optionValue="value"
    :required="false"
    :disabled="!editPaymentInfo"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { DropdownField } from '@centric-os/components/src/composed/validators/dropdown-field';
import { usePaymentInfo } from '../../composables';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes/stores/use-financial-config-store';
import { computed } from 'vue';

// Set localization
const { t } = useI18n();

// Set payment config composable
const { paymentConfigTypes } = usePaymentInfo();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo, isStationInitialSetup } = storeToRefs(fConfigStore);

const fieldName = computed<string>(() => {
  if (isStationInitialSetup.value) {
    return 'paymentConfig.paymentSettings.type';
  }
  return 'type';
});
</script>
